import { render } from "./ConnectionsPageV2.vue?vue&type=template&id=2e5805fa&scoped=true"
import script from "./ConnectionsPageV2.vue?vue&type=script&lang=js"
export * from "./ConnectionsPageV2.vue?vue&type=script&lang=js"

import "./ConnectionsPageV2.vue?vue&type=style&index=0&id=2e5805fa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5805fa"]])

export default __exports__